<template>
  <section class="survey-voting" v-if="details">
    <h2 class="survey-voting__title">{{ details.name }}</h2>
    <p v-if="details.ended">Denne avstemningen er nå avsluttet</p>
    <p
      v-else-if="notloggedin"
    >Du må være innlogget på Aftenbladet.no for å avgi stemme. Logg inn/registrer deg i menyen over.</p>
    <section v-else class="survey-voting__fields">
      <div v-for="(field, key) in details.fields" :key="key">
        <input
          class="survey-voting__input"
          v-model="input[key]"
          v-if="field.type === 'input'"
          type="text"
          :ref="'field-' + key"
          :placeholder="field.text"
        />
        <input
          class="survey-voting__input"
          v-model="input[key]"
          v-else-if="field.type === 'email'"
          type="email"
          :ref="'field-' + key"
          :placeholder="field.text"
        />
      </div>
      <p
        class="survey-voting__terms"
        v-if="terms"
      >Ved å delta i konkurransen godtar du at vi lagrer navn, e-postadresse og bruker-id fra din Schibsted-konto. Opplysningene fjernes etter at konkurransen er over. Opplysningene deles ikke med andre og vil kun bli brukt til å trekke og kontakte vinnere av konkurransen.</p>
      <span
        class="survey-voting__submit"
        :class="[{'survey-voting__submit--disabled' : !valid}, {'survey-voting__submit--loading':loading}]"
        @click="submit"
      >
        Send inn svar
        <span v-if="loading" class="survey-voting__submit-spinn">
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </span>
      </span>
      <p v-if="votedbefore">Du har allerede svart på spørsmål</p>
      <p v-if="thanks">Takk for svar! Vinnere blir kontaktet på e-post.</p>
    </section>
  </section>
</template>

<script>
/*eslint no-useless-escape: "off"*/

import { find, map, mapValues, orderBy, forIn } from 'lodash-es';
import { GET_SURVEYS } from './store';
import { mapGetters } from 'vuex';
import { requestVote } from './utils/firebase-methods';

export default {
  name: 'survey',
  props: {
    survey: {
      type: String,
    },
  },
  data() {
    return {
      notloggedin: true,
      login: null,
      loading: false,
      votedbefore: false,
      thanks: false,
      survey_id: null,
      state: null,
      terms: true,
      input: {},
    };
  },
  computed: {
    ...mapGetters({
      getSurveys: GET_SURVEYS,
    }),
    details() {
      return mapValues(find(this.getSurveys, ['survey', this.survey_id]), (elem, key) => {
        if (key === 'options')
          return orderBy(
            map(elem, (e, id) => {
              return { ...e, id: id };
            }),
            ['pos'],
            ['asc']
          );
        return elem;
      });
    },
    valid() {
      let valid = this.details && this.details.fields ? Object.keys(this.input).length === Object.keys(this.details.fields).length : false;
      forIn(this.input, (input, key) => {
        const field = find(this.details.fields, (f, k) => {
          return k === key;
        });
        let v = false;
        if (field.type === 'email') {
          v = this.validateEmail(input);
        } else if (field.type === 'input') {
          v = input !== null && input !== '';
        }
        if (!v) {
          valid = false;
        }
      });
      return valid;
    },
    options() {
      return {
        type: 'survey',
        spiid: window.localStorage.getItem('spidUserId'),
        survey_id: this.survey_id,
        survey_val: this.input,
      };
    },
  },
  methods: {
    validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    async submit() {
      if (this.valid) {
        this.loading = true;
        this.thanks = false;
        this.votedbefore = false;
        const status = await requestVote(this.options);
        this.loading = false;
        if (status.status) {
          this.thanks = true;
        }
        if (!status.status && status.reason === 'VOTED') {
          this.votedbefore = true;
        }
      }
    },
  },
  mounted() {
    this.survey_id = this.$root.survey;
    this.login = window.setInterval(() => {
      if (window.localStorage.getItem('spidUserId')) {
        this.notloggedin = false;
        clearInterval(this.login);
      }
    }, 250);
  },
};
</script>

<style lang="scss">
@import './styles/settings';
@import './styles/reset';
.survey-voting {
  $block: &;
  display: flex;
  flex-flow: column;
  width: 100%;
  font-family: 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  width: 100%;
  max-width: 980px;
  &__title {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 1rem;
  }
  &__submit {
    cursor: pointer;
    display: inline-flex;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    margin-top: 1rem;
    text-transform: uppercase;
    border-radius: 4px;
    background: get-color(primary);
    color: get-color(light-grey);
    &--disabled {
      opacity: 0.5;
    }
    &-spinn {
      margin-top: 2px;
      margin-left: 7px;
    }
  }
  &__input {
    padding: 0.25rem 0.5rem;
    font-size: 1.2rem;
    border-radius: 4px;
    border: 1px solid get-color(primary);
    margin-bottom: 1rem;
    width: 100%;
    outline: none;
  }
  &__fields {
    width: 100%;
    max-width: 400px;
  }
  &__terms {
    font-size: 0.8rem;
  }
}
</style>
